// With moduleResolution: "bundler", we can export implementations safely
export { JobQueueService } from "./job-queue-service";
export { JobQueueWorker } from "./job-queue-worker";
export { BatchJobManager } from "./batch-job-manager";
export { JobProgressMonitor } from "./job-progress-monitor";
export { BaseJobHandler } from "./base-job-handler";
export type {
  BaseJobHandlerConfig,
  JobDataSchema,
  ProgressStep,
} from "./base-job-handler";

export type {
  IJobQueueService,
  JobHandler,
  EnqueueJob,
  JobInfo,
  JobQueueEnqueueRequest,
  JobQueueDbConfig,
  JobQueueServiceConfig,
  JobQueueWorkerConfig,
  JobQueueWorkerStats,
  IJobQueueWorker,
  IBatchJobManager,
  IJobsNamespace,
} from "./types";
export { JobInfoSchema } from "./types";
export {
  JobStatusSchema,
  JobResultSchema,
  JobStatusEnum,
  JobResultStatusEnum,
  JOB_STATUS,
  type JobStatus,
  type JobResult,
  type JobStatusType,
  type JobResultStatusType,
  JobProgressEventSchema,
  type JobProgressEvent,
  HandlerFailureSchema,
  type HandlerFailure,
} from "./schemas";

// Export batch-related types
export type { BatchOperation, BatchJobStatus, Batch } from "./batch-schemas";

// Export enums and schemas from pure types file (no Drizzle dependencies)
export {
  OperationTypeEnum,
  JobContextSchema,
  JobContextInputSchema,
} from "./schema/types";

// Export types that external packages need
export type {
  OperationType,
  JobContext,
  JobContextInput,
  JobOptions,
  JobStats,
} from "./schema/types";

export {
  createEnqueueJobFn,
  createEnqueueBatchFn,
  createRegisterHandlerFn,
  type EnqueueJobRequest,
  type EnqueueJobFn,
  type EnqueueBatchFn,
  type RegisterHandlerFn,
  type JobsNamespace,
} from "./job-helpers";
